import React from "react"

const PageHeader = ({ title }) => {
    return (
        <header className="header page-header">
            <h1>{title}</h1>
        </header>
    )
}

export default PageHeader
